import { render, staticRenderFns } from "./ContentTag.vue?vue&type=template&id=d9c9c356&scoped=true"
import script from "./ContentTag.vue?vue&type=script&lang=js"
export * from "./ContentTag.vue?vue&type=script&lang=js"
import style0 from "./ContentTag.vue?vue&type=style&index=0&id=d9c9c356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c9c356",
  null
  
)

export default component.exports